import i18n from "../i18next";
import React, { Component } from 'react';
import { loadNotifications } from "../actions";
import { push } from "connected-react-router";
import {
    RESTAURANT_MANAGER,
    MENUU_ADMIN,
    MENUU_MASTER_ADMIN,
    CHAIN_ADMIN,
    ONLINE,
    OFFLINE,
    PAUSED,
    CLOSED,
    OPEN,
    FAIL,
    PENDING,
    SUCCESS,
    REJECTED,
    ACCEPTED,
    AUTO_SYNC,
    IMPORT,
    IMPORT_POS_ORDER_TYPES,
    IMPORT_POS_TENDER_TYPES,
    IMPORT_POS_CHARGE_TYPES,
    PUBLISH,
    PUBLISH_MENU,
    PUBLISH_CATEGORY,
    PUBLISH_PRODUCT,
    PUBLISH_QUESTION,
    PUBLISH_ANSWER,
    US,
    GB,
    IE,
    DE,
    NL,
    BE,
    FR,
    BG,
    CA,
    BR,
    PT,
    IT,
    ES,
    PL,
    AU,
    IN,
    SIMPLE_BILLING,
    ADVANCED_BILLING,
    PARTIALLY_REFUNDED,
    CANCELED,
    REFUNDED,
    CREATE_ORDER,
    CREATE_BILLING_CSV,
    IMPORT_IIKO_ADDRESSES,
    RESTAURANT_PAUSED,
    POS_OFFLINE,
    REJECTED_ORDER,
    IMPORT_COMPLETED,
    PUBLISH_COMPLETED,
    PUBLISH_FAILED,
    EMAIL_SENDING_FAIL,
    SMS_SENDING_FAIL,
    BILLING_CSV_FAIL,
    AUTO_SYNC_FAILED, MT,
    ANDROMEDA_POS_TYPE_ID,
    MENUU_POS_TYPE_ID,
    GOODCOM_POS_TYPE_ID,
    CAPTIVA_TYPE_ID,
    PAR_PIXELPOINT_TYPE_ID,
    PENDING_IN_PROCESS,
    PENDING_FUTURE_ORDER,
    IMPORT_FAILED,
    URGENT_ORDER,
    UPDATE_POS_SETTINGS_FAIL,
    UPDATE_POS_SETTINGS,
    WIPE_MENU,
    WIPE_MENU_FAIL,
    PAUSE_ALL_RESTAURANTS,
    PRODUCT_REPORT,
    DOWNLOAD_ORDERS_REPORT,
    CENTRAL_SEARCH_ORDER_REPORT,
    SEND_ORDER_TO_DELIVERY_PARTNER_FAILURE,
    EXPORT_MENU_FAIL, DELIVERY_ID, COLLECTION_ID, CURBSIDE_ID, INSTORE_ID, CREATE_CUSTOMER_DATA_CSV, CREATE_INVOICE_HISTORY_CSV,
    MX,
    AR,
    CL
} from './Constants';
import DeliverySVG from "../components/common/svgs/DeliverySVG";
import PickUpSVG from "../components/common/svgs/PickUpSVG";
import CurbsideSVG from "../components/common/svgs/CurbsideSVG";
import InStoreSvg from "../components/common/svgs/InStoreSVG";
import CardsSVG from "../components/common/svgs/CardsSVG";
import CashSVG from "../components/common/svgs/CashSVG";
import LoyaltyIconSvg from "../components/common/svgs/LoyaltyIconSVG";

export function convertCheckBoxValueToBoolean({ target }) {
    if (target.value === "true" || target.value === true) {
        return false;
    } else if (target.value === "false" || target.value === false) {
        return true;
    }
}

export function convertStringToBoolean(value) {
    if (value === "true") {
        return true;
    } else if (value === "false") {
        return false;
    } else {
        return value;
    }
}

export function convertSecToMin(value) {
    let min;
    let sec;
    min = Math.floor(value / 60);
    sec = Math.floor(value % 60);

    if (min === 0) {
        return `${sec} ${i18n.t('screens:jobsHistoryScreen.sec')}`;
    } else if (sec === 0 && min > 0) {
        return `${min} ${i18n.t('screens:jobsHistoryScreen.min')}`;
    } else {
        return `${min} ${i18n.t('screens:jobsHistoryScreen.min')} ${sec} ${i18n.t('screens:jobsHistoryScreen.sec')}`;
    }
}

export function convertStringToNumber(value) {
    if (value !== undefined && value !== null) {
        return Number(value);
    } else {
        return value;
    }
}

export function convertNotEmptyStringToNumber(value) {
    if (value !== undefined && value !== null) {
        return Number(value);
    } else if (value === '' || value === 0 || value === null) {
        return null;
    } else {
        return value;
    }
}

// user restrictions
export function userRestrictions(userRole) { // === currentlyLoggedInUser.role
    switch (userRole) {
        case RESTAURANT_MANAGER:
            return true;
        case MENUU_ADMIN:
            return false;
        case MENUU_MASTER_ADMIN:
            return false;
        default:
            return false;
    }
}

export function isUserAllowedToAccessBrand(brand, user) {
    const role = user.role;
    if (role === MENUU_MASTER_ADMIN || role === MENUU_ADMIN) {
        // admins can access any brand
        return true;
    } else if ((brand.manager === undefined || brand.manager === null) && (brand.admin === undefined || brand.admin === null)) {
        return false;
    } else {
        // allow the user to access the brand only if he is the brand manager or brand admin of this brand
        let isAdminOrManager = false;

        if (brand.manager) {
            if (user.id == brand.manager.id) {
                isAdminOrManager = true;
            }
        }
        if (brand.admin) {
            if (user.id == brand.admin.id) {
                isAdminOrManager = true;
            }
        }
        return isAdminOrManager;
    }
}

export function isUserAllowedToAccessRestaurantBrand(restaurant, user) {
    const role = user.role;
    if (role === MENUU_MASTER_ADMIN || role === MENUU_ADMIN) {
        // admins can access any brand
        return true;
    } else if (user.id == restaurant.restaurantChainManagerId || user.id == restaurant.restaurantChainAdminId) {
        // allow the user to access the brand only if he is the brand manager or brand admin of this brand
        return true;
    } else if ((restaurant.chain !== undefined && restaurant.chain !== null &&
        restaurant.chain.manager !== undefined && restaurant.chain.manager !== null &&
        user.id == restaurant.chain.manager.id) || (restaurant.chain !== undefined && restaurant.chain !== null &&
            restaurant.chain.admin !== undefined && restaurant.chain.admin !== null &&
            user.id == restaurant.chain.admin.id)) {

        // allow the user to access the brand only if he is the brand manager or brand admin of this brand
        return true;
    }

    return false;
}

export function isUserAllowedToAddBrands(user) { // This function is also used for Menuu Order Hub Logs
    const role = user.role;
    if (role === MENUU_MASTER_ADMIN || role === MENUU_ADMIN) {
        // only admins can add new brands
        return true;
    } else {
        return false;
    }
}

export function isUserMasterAdmin(user) {
    const role = user.role;
    if (role === MENUU_MASTER_ADMIN) {
        return true;
    }

    return false;
}

export function isUserAllowedToAccessRestaurant(brand, restaurant, user) {
    const role = user.role;
    if (role === MENUU_MASTER_ADMIN || role === MENUU_ADMIN) {
        // admins can access / add any restaurant
        return true;
    } else if (restaurant === undefined || restaurant === null || restaurant.id == -1) {

        if ((brand !== undefined && brand !== null &&
            brand.manager !== undefined && brand.manager !== null &&
            user.id == brand.manager.id) || (brand !== undefined && brand !== null &&
                brand.admin !== undefined && brand.admin !== null &&
                user.id == brand.admin.id)) {

            // if restaurant is undefined this means that the user is trying to add a new restaurant
            // and only the brand manager of this brand can do this
            return true;
        } else {
            return false;
        }
    } else if ((restaurant.manager !== undefined && restaurant.manager !== null && restaurant.manager.id == user.id)
        || (restaurant.admin !== undefined && restaurant.admin !== null && restaurant.admin.id == user.id)) {
        // allow the user to access the restaurant if he is the restaurant manager
        return true;
    } else if ((restaurant.chain !== undefined && restaurant.chain !== null &&
        restaurant.chain.manager !== undefined && restaurant.chain.manager !== null &&
        user.id == restaurant.chain.manager.id) || (restaurant.chain !== undefined && restaurant.chain !== null &&
            restaurant.chain.admin !== undefined && restaurant.chain.admin !== null &&
            user.id == restaurant.chain.admin.id)) {

        // allow the user to access the restaurant if he is the brand manager of this restaurant brand
        return true;
    } else if ((restaurant.id == -1 && brand.manager !== undefined && brand.manager !== null &&
        user.id == brand.manager.id) || (restaurant.id == -1 && brand.admin !== undefined && brand.admin !== null &&
            user.id == brand.admin.id)) {

        // if restaurant id is -1 this means that the user is trying to add a new restaurant
        // and only the brand manager of this brand can do this
        return true;
    }

    return false;
}

export function isUserAllowedToSeePaymentType(user) {

    if (user && user.id !== -1) {
        const role = user.role;
        if (role === MENUU_MASTER_ADMIN || role === MENUU_ADMIN || role === CHAIN_ADMIN) {
            return true;
        } else {
            return false;
        }
    }
    return false;
}

export function isMenuuPOS(posType) {
    const posId = posType.id;
    if (posId === 2) {
        return true;
    } else {
        return false;
    }
}

export function localizeStatuses(status) {
    switch (status) {
        case ACCEPTED:
            return i18n.t('common:statuses.accepted');
        case REJECTED:
            return i18n.t('common:statuses.rejected');
        case SUCCESS:
            return i18n.t('common:statuses.success');
        case FAIL:
            return i18n.t('common:statuses.fail');
        case OPEN:
            return i18n.t('common:statuses.open');
        case CLOSED:
            return i18n.t('common:statuses.closed');
        case ONLINE:
            return i18n.t('screens:restaurantsScreen.online');
        case OFFLINE:
            return i18n.t('screens:restaurantsScreen.offline');
        case PAUSED:
            return i18n.t('screens:restaurantsScreen.paused');
        case PARTIALLY_REFUNDED:
            return i18n.t('screens:orderHistoryScreen.partiallyRefunded');
        case CANCELED:
            return i18n.t('screens:orderHistoryScreen.canceled');
        case REFUNDED:
            return i18n.t('screens:orderHistoryScreen.refunded');
        case PENDING:
            return i18n.t('screens:orderHistoryScreen.pending');
        case PENDING_FUTURE_ORDER:
            return i18n.t('screens:orderHistoryScreen.pendingFutureOrder');
        case CREATE_ORDER:
            return i18n.t('screens:jobsHistoryScreen.createOrder');
        case CREATE_BILLING_CSV:
            return i18n.t('screens:jobsHistoryScreen.createBillingCSV');
        case IMPORT_IIKO_ADDRESSES:
            return i18n.t('screens:jobsHistoryScreen.importIIKOaddresses');
        case RESTAURANT_PAUSED:
            return i18n.t('screens:mainContainer.RESTAURANT_PAUSED');
        case POS_OFFLINE:
            return i18n.t('screens:mainContainer.POS_OFFLINE');
        case REJECTED_ORDER:
            return i18n.t('screens:mainContainer.REJECTED_ORDER');
        case IMPORT_COMPLETED:
            return i18n.t('screens:mainContainer.IMPORT_COMPLETED');
        case PUBLISH_COMPLETED:
            return i18n.t('screens:mainContainer.PUBLISH_COMPLETED');
        case IMPORT_FAILED:
            return i18n.t('screens:mainContainer.IMPORT_FAILED')
        case PUBLISH_FAILED:
            return i18n.t('screens:mainContainer.PUBLISH_FAILED');
        case AUTO_SYNC_FAILED:
            return i18n.t('screens:mainContainer.AUTO_SYNC_FAILED');
        case EMAIL_SENDING_FAIL:
            return i18n.t('screens:mainContainer.EMAIL_SENDING_FAIL');
        case SMS_SENDING_FAIL:
            return i18n.t('screens:mainContainer.SMS_SENDING_FAIL');
        case BILLING_CSV_FAIL:
            return i18n.t('screens:mainContainer.BILLING_CSV_FAIL');
        case PENDING_IN_PROCESS:
            return i18n.t('screens:mainContainer.PENDING_IN_PROCESS');
        case URGENT_ORDER:
            return i18n.t('screens:mainContainer.URGENT_ORDER');
        case UPDATE_POS_SETTINGS_FAIL:
            return i18n.t('screens:mainContainer.UPDATE_POS_SETTINGS_FAIL');
        case UPDATE_POS_SETTINGS:
            return i18n.t('screens:mainContainer.UPDATE_POS_SETTINGS');
        case WIPE_MENU:
            return i18n.t('common:actionTypes.wipeMenu');
        case WIPE_MENU_FAIL:
            return i18n.t('screens:mainContainer.WIPE_MENU_FAIL');
        case CENTRAL_SEARCH_ORDER_REPORT:
            return i18n.t('screens:mainContainer.CENTRAL_SEARCH_ORDER_REPORT');
        case PRODUCT_REPORT:
            return i18n.t('screens:mainContainer.PRODUCT_REPORT');
        case DOWNLOAD_ORDERS_REPORT:
            return i18n.t('screens:mainContainer.DOWNLOAD_ORDERS_REPORT');
        case SEND_ORDER_TO_DELIVERY_PARTNER_FAILURE:
            return i18n.t('screens:mainContainer.SEND_ORDER_TO_DELIVERY_PARTNER_FAILURE');
        default:
            return i18n.t('screens:restaurantsScreen.notConfigured');
    }
}

export function localizeActions(type) {
    switch (type) {
        case AUTO_SYNC:
            return i18n.t('common:actionTypes.autoSync');
        case IMPORT:
            return i18n.t('common:buttons.import');
        case IMPORT_POS_ORDER_TYPES:
            return i18n.t('common:actionTypes.importPosOrders');
        case IMPORT_POS_TENDER_TYPES:
            return i18n.t('common:actionTypes.importPosTenders');
        case IMPORT_POS_CHARGE_TYPES:                             // for future POS'
            return i18n.t('common:actionTypes.importPosCharges');
        case PUBLISH:
            return i18n.t('common:buttons.publish');
        case PUBLISH_MENU:
            return i18n.t('common:actionTypes.publishMenu');
        case PUBLISH_CATEGORY:
            return i18n.t('common:actionTypes.publishCategory');
        case PUBLISH_PRODUCT:
            return i18n.t('common:actionTypes.publishProduct')
        case PUBLISH_QUESTION:
            return i18n.t('common:actionTypes.publishQuestion');
        case PUBLISH_ANSWER:
            return i18n.t('common:actionTypes.publishAnswer');
        case CREATE_ORDER:
            return i18n.t('common:actionTypes.createOrder');
        case WIPE_MENU:
            return i18n.t('common:actionTypes.wipeMenu');
        case PAUSE_ALL_RESTAURANTS:
            return i18n.t('common:actionTypes.pauseAllRestaurants');
        case PRODUCT_REPORT:
            return i18n.t('screens:mainContainer.PRODUCT_REPORT');
        case DOWNLOAD_ORDERS_REPORT:
            return i18n.t('screens:mainContainer.DOWNLOAD_ORDERS_REPORT');
        case CENTRAL_SEARCH_ORDER_REPORT:
            return i18n.t('screens:mainContainer.CENTRAL_SEARCH_ORDER_REPORT');
        case CREATE_BILLING_CSV:
            return i18n.t('screens:jobsHistoryScreen.createBillingCSV');
        case IMPORT_IIKO_ADDRESSES:
            return i18n.t('screens:jobsHistoryScreen.importIIKOaddresses');
        case EXPORT_MENU_FAIL:
            return i18n.t('screens:jobsHistoryScreen.exportMenuFail');
        case UPDATE_POS_SETTINGS:
            return i18n.t('screens:mainContainer.UPDATE_POS_SETTINGS');
        case CREATE_CUSTOMER_DATA_CSV:
            return i18n.t('screens:jobsHistoryScreen.downloadCustomersData');
        case CREATE_INVOICE_HISTORY_CSV:
            return i18n.t('screens:jobsHistoryScreen.createInvoiceHistoryCSV'); 
        default:
            return;
    }
}

export function localizeCountryNames(country) {
    switch (country) {
        case US:
            return i18n.t('common:languages.us');
        case GB:
            return i18n.t('common:languages.uk');
        case IE:
            return i18n.t('common:languages.ie');
        case DE:
            return i18n.t('common:languages.de');
        case NL:
            return i18n.t('common:languages.nl');
        case BE:
            return i18n.t('common:languages.be');
        case FR:
            return i18n.t('common:languages.fr');
        case BG:
            return i18n.t('common:languages.bg');
        case CA:
            return i18n.t('common:languages.ca');
        case MT:
            return i18n.t('common:languages.mt');
        case BR:
            return i18n.t('common:languages.br');
        case PT:
            return i18n.t('common:languages.pt');
        case IT:
            return i18n.t('common:languages.it');
        case ES:
            return i18n.t('common:languages.es');
        case PL:
            return i18n.t('common:languages.pl');
        case AU:
            return i18n.t('common:languages.au');
        case IN:
            return i18n.t('common:languages.in');
        case MX:
            return i18n.t('common:languages.mx');
        case AR:
            return i18n.t('common:languages.ar');
        case CL:
            return i18n.t('common:languages.cl');
        case 'NA':
            return i18n.t('common:languages.naDelCustomer');
        default:
            return;
    }
}

export function countryNameToCountryCode(code) {
    switch (code) {
        case 'United States':
            return 'US';
        case 'United Kingdom':
            return 'GB';
        case 'Ireland':
            return 'IE';
        case 'Germany':
            return 'DE';
        case 'Netherlands':
            return 'NL';
        case 'Belgium':
            return 'BE';
        case 'France':
            return 'FR';
        case 'Bulgaria':
            return 'BG';
        case 'Canada':
            return 'CA';
        case 'Malta':
            return 'MT';
        default:
            return;
    }
}

export function getCurrencySymbolAccToCountry(countryAbbrv) {
    switch (countryAbbrv) {
        case IE:
        case DE:
        case NL: // Euro
        case BE:
        case FR:
            return 'eur';
        case 'UK':
        case GB: // Great Britain Pound
            return 'gbp';
        case US: // USA Dollar
        case CA: // Canadian Dollar
        case AU: // Australian Dollar
            return 'usd';
        case BG: // Bulgarian Lev
            return 'bgn';
        case MX: // Mexican Peso
            return 'mxn';
        case AR: // Argentine Peso
            return 'ars'
        case CL: // Chilean Peso
            return 'clp'
        default:
            return 'eur';
    }
}

//Notifications
export function startNotificationsTimer(importInProgress, publishInProgress, notifications) {

    if ((importInProgress !== undefined && importInProgress !== null
        && notifications !== undefined && notifications !== null)
        || (publishInProgress !== undefined && publishInProgress !== null)) {

        if (importInProgress || publishInProgress) {
            let timer = setInterval(() => {
                loadNotifications(notifications.length, clearInterval(timer));
            }, 15000)
        }
    }
}

// Redirect to page not found

export function redirectToPageNotFound(dispatch) {
    dispatch(push(`/page-not-found`));
}

export function capitalizeFirstLetter(word) {
    if (word !== undefined) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }
}

export function capitalizeAllLetters(word) {
    return word.toUpperCase();
}

export function convertToLowerCase(word) {
    if (word !== undefined) {
        return word.charAt(0).toLowerCase() + word.slice(1);
    }
}


export function negativeIntegersValidation(e) {

    let inputKeyCode = e.keyCode ? e.keyCode : e.which;

    if (inputKeyCode != null) {
        if (inputKeyCode == 45 || inputKeyCode == 46 || inputKeyCode == 43
            || inputKeyCode == 69 || inputKeyCode == 101) {
            e.preventDefault();
        }
    }
}

export const negativeDecimalsValidation = (e) => {
    let inputKeyCode = e.keyCode ? e.keyCode : e.which;

    if (inputKeyCode != null) {
        if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
            || inputKeyCode == 101) e.preventDefault();
    }
}

export const transformProductsComingFromServer = (products, applyPromotion) => {
    let productsWithTransformedIds = [];
    let allProducts = [];
    let updatedProduct;

    products.map(product => {
        updatedProduct = {
            product: {
                id: applyPromotion === true ? product.product.id : product.productId,
            },
            instruction: product.instruction,
            mealDeal: product.mealDeal,
            mealDealProduct: product.mealDealProduct,
            name: product.name,
            orderQuestions: product.sortedOrderQuestions ? product.sortedOrderQuestions : [],//product.orderQuestions,
            parentProductId: applyPromotion === true ? null : product.parentProductId,
            price: product.price,
            productId: applyPromotion === true ? product.product.id : product.productId,
            promotionFreeProduct: product.promotionFreeProduct,
            quantity: product.quantity,
            sizeName: product.sizeName,
            tax: applyPromotion === true ? product.tax : product.tax,
            thumbnailPath: product.thumbnailPath,
            totalPrice: applyPromotion === true ? null : product.totalPrice,
            description: product.description ? product.description : null,
            basicPrice: product.basicPrice ? product.basicPrice : null
        }

        // if(orderHistory == true) {
        //     updatedProduct['orderHistoryProduct'] = true;
        // }

        productsWithTransformedIds.push(updatedProduct)
    });

    for (let i = 0; i < productsWithTransformedIds.length; i++) {             // Iterating all incoming products
        const mealDealProductsArray = new Array();                            // Create new array for the Meal Deals
        let product = productsWithTransformedIds[i];
        let nextProduct = productsWithTransformedIds[i + 1] ? productsWithTransformedIds[i + 1] : {};

        if (product.mealDeal == true) {                                // Deals & deal products
            mealDealProductsArray.push(product);                          // push product /the deal is always first
            if (!nextProduct.mealDealProduct) {
                allProducts.push(mealDealProductsArray);
            } else {
                for (let k = (i + 1); k < productsWithTransformedIds.length; k++) {             // Iterating the products again but without the one already in the array
                    let mealDealProduct = productsWithTransformedIds[k];
                    if (mealDealProduct.mealDealProduct) {                    // Push all Meal Deal Products untill it reaches the array end...
                        mealDealProductsArray.push(mealDealProduct);
                        if (k == productsWithTransformedIds.length - 1) {
                            allProducts.push(mealDealProductsArray);
                            return allProducts;
                        }
                    } else {                                                  // ...or new Meal Deal.
                        i = k - 1;                                            // Then sets the iterator (i) to the next un-added item
                        allProducts.push(mealDealProductsArray);
                        break;
                    }
                }
            }

        } else {
            allProducts.push(product);
        }
    }
    return allProducts;
}

export const transformProductPrice = (price) => {

    if (price !== undefined && price !== null && typeof price == 'number') {
        const tranformedPrice = price.toFixed(2);

        return tranformedPrice;
    }
}

export const getMaxRefundAmount = (orderTotal, refunds) => {
    let creditCardsRefund = refunds ? Array.isArray(refunds) ? refunds.filter(refund => refund.refundType !== 'GIFT_CARD') : null : null;
    let refundValue = 0;

    if(creditCardsRefund) {
        for (let i = 0; i < creditCardsRefund.length; i++) {
            refundValue += creditCardsRefund[i].amount;
        }
        
        const maxRefundValue = orderTotal - refundValue;
        return maxRefundValue;
    } else {
        return null;
    }
}

export const getMaxGiftCardsRefundAmount = (orderTotal, refunds) => {
    let giftCardsRefund = refunds ? Array.isArray(refunds) ? refunds.filter(refund => refund.refundType === 'GIFT_CARD') : null : null;
    let refundValue = 0;

    if(giftCardsRefund) {
        for (let i = 0; i < giftCardsRefund.length; i++) {
            refundValue += giftCardsRefund[i].amount;
        }
        
        const maxRefundValue = orderTotal - refundValue;
        return maxRefundValue;
    } else {
        return null;
    }
}

export const getAllUrlParams = (url) => {

    // get query string from url (optional) or window
    let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    let queryParams = {};

    // if query string exists
    if (queryString) {

        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        let arr = queryString.split('&');

        for (let i = 0; i < arr.length; i++) {
            // separate the keys and the values
            let a = arr[i].split('=');

            // set parameter name and value (use 'true' if empty)
            let paramName = a[0];
            let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

            // (optional) keep case consistent
            // paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string') paramValue = paramValue;

            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
            if (paramName.match(/\[(\d+)?\]$/)) {

                // create key if it doesn't exist
                let key = paramName.replace(/\[(\d+)?\]/, '');
                if (!queryParams[key]) queryParams[key] = [];

                // if it's an indexed array e.g. colors[2]
                if (paramName.match(/\[\d+\]$/)) {
                    // get the index value and add the entry at the appropriate position
                    let index = /\[(\d+)\]/.exec(paramName)[1];
                    queryParams[key][index] = paramValue;
                } else {
                    // otherwise add the value to the end of the array
                    queryParams[key].push(paramValue);
                }
            } else {
                // we're dealing with a string
                if (!queryParams[paramName]) {
                    // if it doesn't exist, create property
                    queryParams[paramName] = paramValue;
                } else if (queryParams[paramName] && typeof queryParams[paramName] === 'string') {
                    // if property does exist and it's a string, convert it to an array
                    queryParams[paramName] = [queryParams[paramName]];
                    queryParams[paramName].push(paramValue);
                } else {
                    // otherwise add the property
                    queryParams[paramName].push(paramValue);
                }
            }
        }
    }

    return queryParams;
}

export const getDayId = (day) => {
    switch (day) {
        case "Sunday":
            return 1;
            break;
        case "Monday":
            return 2;
            break;
        case "Thuesday":
            return 3;
            break;
        case "Wednesday":
            return 4;
            break;
        case "Thursday":
            return 5;
            break;
        case "Friday":
            return 6;
            break;
        case "Saturday":
            return 7;
            break;
        default:
        // code block
    }
}

export const getDayName = (dayId) => {
    switch (dayId) {
        case 1:
            return i18n.t(`screens:openingHoursScreen.weekday_1`);
            break;
        case 2:
            return i18n.t(`screens:openingHoursScreen.weekday_2`);
            break;
        case 3:
            return i18n.t(`screens:openingHoursScreen.weekday_3`);
            break;
        case 4:
            return i18n.t(`screens:openingHoursScreen.weekday_4`);
            break;
        case 5:
            return i18n.t(`screens:openingHoursScreen.weekday_5`);
            break;
        case 6:
            return i18n.t(`screens:openingHoursScreen.weekday_6`);
            break;
        case 7:
            return i18n.t(`screens:openingHoursScreen.weekday_7`);
            break;
        default:
        // code block
    }
}

export const calculateDiscount = (order) => {

    let tip = order.tip ? order.tip : 0;
    let vat = order.totalTax ? order.totalTax : 0;

    let deliveryFee = order.deliveryCharge ? order.deliveryCharge : 0;
    let priceBeforeDiscount = order.priceBeforeDiscount;

    const totalPrice = order.total;
    let discount = totalPrice - priceBeforeDiscount - vat - tip - deliveryFee - order.orderDeposit;

    return discount;
}


export const transformToLocalize = (orderType) => { // Transforms item.value so it can be translated.
    if (orderType) {
        switch (orderType.value) {
            case "Collection":
                return "collection";
            case "Delivery":
                return "delivery";
            case "Dine In":
                return "dinein"
            case "Curbside":
                return "curbside";
            default:
                return;
        }
    }
}

export const getSelectedPaymentType = (simpleBilling) => {
    const simpleBillingPaymentType = SIMPLE_BILLING;
    const advancedBillingPaymentType = ADVANCED_BILLING;

    if (simpleBilling) {
        return simpleBillingPaymentType;
    } else {
        return advancedBillingPaymentType;
    }
};

export const getCurrencySymbol = (currency) => {
    if (currency) {
        switch (currency) {
            case 'eur': // Euro
                return '€';
            case 'gbp': // Great Britain Pound
                return '£';
            case 'usd': // USA Dollar
            case 'cad': // Canadian Dollar
            case 'aud': // Australian Dollar
            case 'mxn': // Mexican Peso
            case 'ars': // Argentine Peso
            case 'clp': // Chilean Peso
                return '$';
            case 'bgn': // Bulgarian Lev
                return ' лв';
            case 'inr':
                return '₹'
            default:
                return '€';
        }
    }
    return '€';
}


export const getPriceWithCurrencySymbol = (price, currency) => {
    try {
        price = Number(price).toFixed(2);
    } catch (e) {
    }
    if (currency) {
        switch (currency) {
            case 'eur': // Euro
                return '€' + price;
            case 'gbp': // Great Britain Pound
                return '£' + price;
            case 'usd': // USA Dollar
            case 'cad': // Canada Dollar
            case 'aud': // Australian Dollar
            case 'mxn': // Mexican Peso
            case 'ars': // Argentine Peso
            case 'clp': // Chilean Peso
                return '$' + price;
            case 'bgn': // Bulgaria Lev
                return price + ' лв';
            case 'inr': // Indian Rupee
                return '₹' + price;
            default:
                return '€' + price;
        }
    }

    return '€' + price;
}

export const posSupportsEditableFreeToppings = (currentPOS) => {

    return currentPOS.type.supportCsvFiles;
};


export const prependTimeWithZero = (timeValue) => {
    if (timeValue < 10) {
        return `0${timeValue}`
    } else {
        return timeValue;
    }
}

// DEEPCOPYING
export const newDeepCopy = (product) => {
    let destructuredProduct = Object.entries(product);
    let productCopy = {};

    destructuredProduct.map(keyValuePair => {
        if (Array.isArray(keyValuePair[1])) {
            productCopy = {
                ...productCopy,
                [keyValuePair[0]]: innerDeepCopy(keyValuePair[1])
            };
        } else {
            productCopy = {
                ...productCopy,
                [keyValuePair[0]]: keyValuePair[1]
            };
        }
    });

    return productCopy;
}

const innerDeepCopy = (arr) => {
    let newArr = [];
    arr.map(arrEl => {
        let newArrEl = newDeepCopy(arrEl);
        newArr.push(newArrEl);
    });

    return newArr;
}


export const renderOrderTypeSrc = (orderTypeId, style) => {
    if (orderTypeId) {
        let svgStyle = style ? style : {};
        switch (orderTypeId) {
            case DELIVERY_ID:
                return <DeliverySVG width={29} height={29} fill={'#0288D1'} style={svgStyle} />
                break;
            case COLLECTION_ID:
                return <PickUpSVG width={24} height={24} fill={'#0288D1'} style={svgStyle} />
                break;
            case CURBSIDE_ID:
                return <CurbsideSVG width={30} height={26} fill={'#0288D1'} style={svgStyle} />
                break;
            case INSTORE_ID:
                return <InStoreSvg width={26} height={26} fill={'#0288D1'} style={svgStyle} />
                break;
            default:
                return null
        }
    } else {
        return null
    }
}

export const renderPaymentTypeIcon = (paymentTypeId, style, isOnlyLoyalty, reportScreen) => {

    if (paymentTypeId) {
        let svgStyle = style ? style : {};

        switch (paymentTypeId) {
            case 1:
                return <CardsSVG width={24} height={24} fill={'#0288D1'} style={svgStyle} />;
                break;
            case 2:
                return (
                    <CashSVG width={26} height={28} fill={'#0288D1'} style={svgStyle} />
                )
                break;
            case 3:
                let loyalyIconColor = reportScreen ? '#0288D1' : isOnlyLoyalty ? '#0288D1' : '#808080';
                return (
                    <LoyaltyIconSvg width={24} height={26} fill={loyalyIconColor} style={svgStyle} />
                )
                break;
            default:
                return null
        }
    } else {
        return null
    }

}

export const transformActionContent = (action) => {
    switch (action) {
        case i18n.t('screens:eventTrackingScreen.pause'):
            return 1;
        case i18n.t('screens:eventTrackingScreen.unpause'):
            return 2;
        case i18n.t('screens:eventTrackingScreen.openingHoursGeneral'):
            return 3;
        case i18n.t('screens:eventTrackingScreen.openingHoursCollection'):
            return 4;
        case i18n.t('screens:eventTrackingScreen.deliverySettings'):
            return 5;
        case i18n.t('screens:eventTrackingScreen.daysOff'):
            return 6;
        case i18n.t('screens:eventTrackingScreen.menuCreate'):
            return 7;
        case i18n.t('screens:eventTrackingScreen.menuChange'):
            return 8;
        case i18n.t('screens:eventTrackingScreen.menuDelete'):
            return 9;
        case i18n.t('screens:eventTrackingScreen.categoryCreate'):
            return 10;
        case i18n.t('screens:eventTrackingScreen.categoryChange'):
            return 11;
        case i18n.t('screens:eventTrackingScreen.categoryDelete'):
            return 12;
        case i18n.t('screens:eventTrackingScreen.productCreate'):
            return 13;
        case i18n.t('screens:eventTrackingScreen.productChange'):
            return 14;
        case i18n.t('screens:eventTrackingScreen.productDelete'):
            return 15;
        case i18n.t('screens:eventTrackingScreen.questionCreate'):
            return 16;
        case i18n.t('screens:eventTrackingScreen.questionChange'):
            return 17;
        case i18n.t('screens:eventTrackingScreen.questionDelete'):
            return 18;
        case i18n.t('screens:eventTrackingScreen.answerCreate'):
            return 19;
        case i18n.t('screens:eventTrackingScreen.answerChange'):
            return 20;
        case i18n.t('screens:eventTrackingScreen.answerDelete'):
            return 21;
        case i18n.t('screens:eventTrackingScreen.refundPartial'):
            return 22;
        case i18n.t('screens:eventTrackingScreen.refundFull'):
            return 23;
        case i18n.t('screens:eventTrackingScreen.manualAccept'):
            return 24;
        case i18n.t('screens:eventTrackingScreen.manualReject'):
            return 25;
        case i18n.t('screens:eventTrackingScreen.manualCancel'):
            return 26;
        case i18n.t('screens:eventTrackingScreen.promotionCreate'):
            return 27;
        case i18n.t('screens:eventTrackingScreen.promotionEdit'):
            return 28;
        case i18n.t('screens:eventTrackingScreen.deliveryOpeningHours'):
            return 29;
        case i18n.t('screens:eventTrackingScreen.promotionDelete'):
            return 30;
        case i18n.t('screens:eventTrackingScreen.pickupSettings'):
            return 31;
        case i18n.t('screens:eventTrackingScreen.dinePaySettings'):
            return 32;
        case i18n.t('screens:eventTrackingScreen.curbsideSettings'):
            return 33;
        case i18n.t('screens:eventTrackingScreen.generalSettings'):
            return 34;
        case i18n.t('screens:eventTrackingScreen.manualResend'):
            return 35;
        case i18n.t('screens:eventTrackingScreen.additionalChargeCreate'):
            return 36;
        case i18n.t('screens:eventTrackingScreen.additionalChargeUpdate'):
            return 37;
        case i18n.t('screens:eventTrackingScreen.additionalChargeDelete'):
            return 38;
        case i18n.t('screens:eventTrackingScreen.additionalChargeCreateCsv'):
            return 39;
        case i18n.t('screens:eventTrackingScreen.companyInfoCreate'):
            return 40;
        case i18n.t('screens:eventTrackingScreen.companyInfoUpdate'):
            return 41;
        case i18n.t('screens:eventTrackingScreen.bankAccountCreate'):
            return 42;
        case i18n.t('screens:eventTrackingScreen.bankAccountUpdate'):
            return 43;
        case i18n.t('screens:eventTrackingScreen.restaurantSubscriptionCreate'):
            return 44;
        case i18n.t('screens:eventTrackingScreen.restaurantSubscriptionUpdate'):
            return 45;
        case i18n.t('screens:eventTrackingScreen.activateRestaurant'):
            return 48;
        case i18n.t('screens:eventTrackingScreen.deactivateRestaurant'):
            return 49;
        default:
            return
    }
}

export const localizeCurrency = (currency) => {
    switch(currency) {
        case 'usd':
            return i18n.t('screens:paymentScreen.unitedStatesDollar');
        case 'cad':
            return i18n.t('screens:paymentScreen.canadianDollar');
        case 'eur':
            return i18n.t('screens:paymentScreen.euro');
        case 'gbp':
            return i18n.t('screens:paymentScreen.britishPound');
        case 'aud':
            return i18n.t('screens:paymentScreen.australianDollar');
        case 'mxn':
            return i18n.t('screens:paymentScreen.mexicanPeso');
        case 'ars':
            return i18n.t('screens:paymentScreen.argentinePeso');
        case 'clp': 
            return i18n.t('screens:paymentScreen.chileanPeso');
        default: 
            return
    }
}

export const localizeArea = (area) => {
    switch(area) {
        case 'EU':
            return i18n.t('common:areas.europe');
        case 'UK':
            return i18n.t('common:areas.unitedKingdom');
        case 'US':
            return i18n.t('common:areas.unitedStates');
        case 'CA':
            return i18n.t('common:areas.canada');
        case 'AU':
            return i18n.t('common:areas.australia');
        case 'MX':
            return i18n.t('common:areas.mexico');
        case 'AR':
            return i18n.t('common:areas.argentina');
        case 'CL':
            return i18n.t('common:areas.chile');
    }
}

export const localizeDiscountType = (type) => {
    switch(type) {
        case 'LOYALTY':
            return i18n.t('screens:customerInsightScreen.loyalty');
        case 'FREE_PRODUCT':
            return i18n.t('screens:customerInsightScreen.freeProduct');
        case 'PRICE_DISCOUNT':
            return i18n.t('screens:customerInsightScreen.priceDiscount');
        case 'MARKETING_AUTOMATION':
            return i18n.t('screens:customerInsightScreen.marketingAutomation');
        case 'COMBO_DEAL':
            return i18n.t('screens:customerInsightScreen.comboDeal');
    }
}


// WEBPACK FOOTER //
// ./src/utils/CommonUtils.js